import { adobeDispatcher } from '../../common/utilities/adobeAnalytics';

export enum TrackingKey {
  page = 'page',
  event = 'event',
  user = 'user',
}

export interface TrackingDetail {
  page?: string;
  category?: string;
  action?: string;
  label?: string;
  value?: number | string | null;
}

export interface TrackingData {
  type: TrackingKey;
  detail: TrackingDetail;
}

export interface TrackingOptions {
  dispatchOnMount: boolean;
}

export interface AdobeOptions {
  scriptSrc: string;
  async?: boolean;
}

export const trackPage = (pageName: string) => {  
  adobeDispatcher({
    type: TrackingKey.page,
    detail: { page: pageName },
  });
};

export const trackEvent = (category: string, action: string, label: any, value?: any) => {  
  adobeDispatcher({
    type: TrackingKey.event,
    detail: { category, action, label, value },
  });
};
